import { gql } from '@apollo/client';

export * from './initOauthIntegrationAuth.mutation.generated';

export const INIT_OAUTH_INTEGRATION_AUTH = gql`
  mutation initOauthIntegrationAuth($provider: OauthIntegrationProviderEnum!, $options: IntegrationAuthOptionsInput) {
    initOauthIntegrationAuth(input: { provider: $provider, options: $options }) {
      success
      errors
      integrationAuth {
        url
        stateToken
      }
    }
  }
`;
